import React from 'react';
import { Info, Package } from 'lucide-react';

export function StatCard({ Icon, label, value, hasInfo = true, suffix }) {
  return (
    <div className="rounded-2xl bg-white border border-[#ECE6FA] p-4 md:p-5 flex items-start gap-3 hover:border-[#C7BFF5] transition-colors">
      <div className="w-10 h-10 rounded-xl bg-[#F1ECFE] flex items-center justify-center shrink-0">
        <Icon size={18} className="text-[#5B4FE8]" />
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-1 text-[12.5px] text-[#4A4463]">
          <span className="truncate">{label}</span>
          {hasInfo && <Info size={11} className="text-[#A39DB8] shrink-0" />}
        </div>
        <div className="mt-2 text-[20px] md:text-[22px] font-bold text-[#1A1533] leading-none">
          {value}{suffix && <span className="text-[13px] text-[#4A4463] font-medium ml-1">{suffix}</span>}
        </div>
      </div>
    </div>
  );
}

function ChartTabs({ tab, setTab }) {
  return (
    <div className="inline-flex rounded-full bg-[#F1ECFE] p-1">
      <button
        onClick={() => setTab('applicants')}
        className={`px-3 py-1 rounded-full text-[11.5px] md:text-[12px] font-semibold transition-colors ${
          tab === 'applicants' ? 'bg-white text-[#5B4FE8] shadow-sm' : 'text-[#4A4463]'
        }`}
      >Applicants</button>
      <button
        onClick={() => setTab('ai-vetted')}
        className={`px-3 py-1 rounded-full text-[11.5px] md:text-[12px] font-semibold transition-colors ${
          tab === 'ai-vetted' ? 'bg-white text-[#5B4FE8] shadow-sm' : 'text-[#4A4463]'
        }`}
      >AI-vetted</button>
    </div>
  );
}

export function EmptyChartCard({ title, showTabs }) {
  const [tab, setTab] = React.useState('applicants');
  return (
    <div className="rounded-2xl bg-white border border-[#ECE6FA] p-4 md:p-5 min-h-[300px] md:min-h-[340px] flex flex-col">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-1.5">
          <h3 className="text-[14px] md:text-[15px] font-bold text-[#1A1533]">{title}</h3>
          <Info size={12} className="text-[#A39DB8]" />
        </div>
        {showTabs && <ChartTabs tab={tab} setTab={setTab} />}
      </div>
      <div className="flex-1 flex flex-col items-center justify-center text-[#8A83A5]">
        <Package size={54} className="text-[#C7BFF5]" strokeWidth={1.5} />
        <p className="text-[13px] mt-2">No data to display</p>
      </div>
    </div>
  );
}
